/* eslint-disable @typescript-eslint/typedef */
import { createSlice } from '@reduxjs/toolkit';

import {
  SetMessageOverviewsPayload,
  SetMessageOwnerPayload,
  SetMessagesPayload,
  SetSupportTemplatePayload,
  SupportState
} from '../../../types/state/support.types';

export const initialState: SupportState = {
  supportTemplate: undefined,
  messageOverviews: [],
  messageOwner: undefined,
  messages: []
};

const SupportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setSupportTemplate: (state, action: SetSupportTemplatePayload): void => {
      state.supportTemplate = action.payload;
    },
    setMessageOverviews: (state, action: SetMessageOverviewsPayload): void => {
      state.messageOverviews = action.payload;
    },
    setMessageOwner: (state, action: SetMessageOwnerPayload): void => {
      state.messageOwner = action.payload;
    },
    setMessages: (state, action: SetMessagesPayload): void => {
      state.messages = action.payload;
    }
  }
});

export const { setSupportTemplate, setMessageOverviews, setMessageOwner, setMessages } = SupportSlice.actions;

export default SupportSlice.reducer;
